import { createFileRoute, redirect } from "@tanstack/react-router";
import { useAuthStore } from "@/store/authStore";
import InstitutionDashboard from "./dashboard";

export const Route = createFileRoute("/institution")({
  beforeLoad: () => {
    const { user } = useAuthStore.getState();
    // The API has no institution role yet, so this compares as a plain string
    // rather than widening UserRole with a value the backend never issues.
    if (!user || String(user.role) !== "institution") {
      throw redirect({ to: "/auth/login" });
    }
  },
  component: InstitutionDashboard,
});
